import "./Footer.css";

export const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-container">
				<p>
					© {new Date().getFullYear()} Samuel Adafia. Built with passion and
					precision.
				</p>
			</div>
		</footer>
	);
};
